// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 207 ? "89adb2d6" : chunkId) + "." + {"207":"a7e3cae2089da02f","714":"ffeeba82482409ba"}[chunkId] + ".js";
};